<template>
  <div class="p-fluid" style="direction: rtl">
    <div class="card  p-d-flex p-jc-center">
      <DataTable
          :rowClass="rowClass"
          :value="data"

          :selection.sync="selectedItemsSubjectTracing"
          :resizableColumns="false"
          @cell-edit-complete="onCellEditComplete"
          columnResizeMode="fit"
          dataKey="id"
          class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
          stateStorage="local"
          stateKey="user-data-state"
          editMode="cell"
          :filters="filters"
          :loading="loading"
          sortField="grade.hebrewName"
          :sortOrder="1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 20, 50]"
          currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
      >
        <!-- header -->

        <template #header>
          <div class="p-p-2 table-header">
            <div class="p-m-1 p-d-inline-flex">
              <h1 style="text-align: center">אירועי משמעת</h1>
            </div>

            <div class="p-d-flex">

              <Button
                  v-tooltip.top="'מחיקה'"
                  v-if="selectedItemsSubjectTracing.length > 0"
                  icon="pi pi-trash"
                  class="p-mr-2 p-button-danger"
                  @click="isDialogDelete = true"
              />
              <Button
                  v-tooltip.top="'הוספה'"
                  icon="pi pi-plus"
                  class="p-mr-2 p-button-success"
                  @click="isDialogAdd = true"
              />
            </div>
          </div>
        </template>
        <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

        <!-- id -->

        <Column
            headerStyle="width: 5%;"
            bodyStyle="text-align: right; overflow: visible ; color: #757575;"
            field="id"
            header="ת.ז"
            sortable
        >
          <template #filter>
            <InputText
                type="text"
                v-model="filters['id']"
                class="p-column-filter"
                placeholder="חפש לפי ת.ז."
            />
          </template>
        </Column>

        <!-- v-for -->
        <Column
            headerStyle="text-align: rtl"
            bodyStyle="text-align: right; overflow: visible"
            sortable
            v-for="col of columns"
            :field="col.field"
            :header="col.header"
            :key="col.field"
        >
          <template #filter>
            <InputText
                type="text"
                v-model="filters[col.field]"
                class="p-column-filter"
                :placeholder="`חפש לפי ${col.header}`"
            />
          </template>
          <template #editor="slotProps">
            <InputText
                v-if="slotProps.column.field !== 'id'"
                :value="slotProps.data[slotProps.column.field]"
                @input="onCellEdit($event, slotProps)"
            />
            <div v-else>{{ slotProps.data[slotProps.column.field] }}</div>
          </template>
        </Column>
        <!-- v-for -->

        <!-- role -->

        <Column
            headerStyle="width: 20%; text-align: rtl"
            bodyStyle="text-align: right; overflow: visible"
            sortable
            sortField="role"
            :field="'role'"
            :header="'הרשאה'"
            :key="'role'"
            filterMatchMode="in"
        >
          <template #filter>
            <MultiSelect
                v-model="filters['role']"
                :options="roles"
                :showClear="true"
                placeholder="סנן לפי הרשאה"
                class="multiselect-custom"
            >
              <template #option="slotProps">
                <span>{{ getRoleLabel(slotProps.option) }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="a in slotProps.value" :key="a">
                    {{ getRoleLabel(a) }},
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>
          <template #editor="slotProps">
            <Dropdown

                :value="slotProps.data[slotProps.column.field]"
                :options="roles"
                @input="onCellEdit($event, slotProps)"
            >
              <template #option="slotProps">
                <span>{{ getRoleLabel(slotProps.option) }}</span>
              </template>
              <template #value="slotProps">
                <div v-if="slotProps.value">
                  <span>{{ getRoleLabel(slotProps.value) }}</span>
                </div>
                <span v-else>
                  {{ slotProps.placeholder }}
                </span>
              </template>
            </Dropdown>

          </template>
          <template #body="slotProps">
            {{ getRoleLabel(slotProps.data.role) }}
          </template>
        </Column>

        <!-- type -->

        <Column
            headerStyle="width: 15%; text-align: rtl"
            bodyStyle="text-align: right; overflow: visible"
            sortable
            sortField="type"
            :field="'type'"
            :header="'סוג'"
            :key="'type'"
            filterMatchMode="in"
        >
          <template #filter>
            <MultiSelect
                v-model="filters['type']"
                :options="types"
                :showClear="true"
                placeholder="סנן לפי סוג"
                class="multiselect-custom"
            >
              <template #option="slotProps">
                <span class="subject-tracking " :class="slotProps.option">
                  {{ getTypeLabel(slotProps.option) }}
                </span>
              </template>
              <template #value="slotProps">
                <div v-if="!slotProps.value || slotProps.value.length === 0">
                  {{ slotProps.placeholder }}
                </div>
                <span v-else>
                  <span v-for="a in slotProps.value" :key="a">
                    <span class="subject-tracking " :class="a">

                    {{ getTypeLabel(a) }},
                    </span>
                  </span>
                </span>
              </template>
            </MultiSelect>
          </template>
          <template #editor="slotProps">
            <Dropdown

                :value="slotProps.data[slotProps.column.field]"
                :options="types"
                @input="onCellEdit($event, slotProps)"
            >
              <template #option="slotProps">
                <span class="subject-tracking " :class="slotProps.option">
                  {{ getTypeLabel(slotProps.option) }}
                </span>
              </template>
              <template #value="slotProps">
                <div v-if="slotProps.value">
                  <span class="subject-tracking " :class="slotProps.value">
                    {{ getTypeLabel(slotProps.value) }}
                  </span>
                </div>
                <span v-else>
                  {{ slotProps.placeholder }}
                </span>
              </template>
            </Dropdown>

          </template>
          <template #body="slotProps">
            <div class="subject-tracking " :class="slotProps.data.type">
              {{ getTypeLabel(slotProps.data.type) }}
            </div>
          </template>
        </Column>
          <Column
                  headerStyle="width: 5%; text-align: rtl"
                  bodyStyle="text-align: right; overflow: visible"
                  sortable
                  sortField="type"
                  :field="'reportActive'"
                  :header="'לתעודה'"
                  :key="'id'"
                  filterMatchMode="in"
          >
              <template #editor="slotProps">
                  <checkbox v-model="slotProps.data.reportActive" :binary="true"></checkbox>


              </template>
              <template #body="slotProps">
                  <checkbox v-model="slotProps.data.reportActive" :binary="true"></checkbox>
<!--                  <div class="subject-tracking " :class="slotProps.data.type">-->
<!--                      {{ getTypeLabel(slotProps.data.type) }}-->
<!--                  </div>-->
              </template>
          </Column>
          <Column
                  headerStyle="width: 5%; text-align: rtl"
                  bodyStyle="text-align: right; overflow: visible"
                  sortable
                  sortField="type"
                  :field="'alert'"
                  :header="'להתריא'"
                  :key="'id'"
                  filterMatchMode="in"
          >
              <template #editor="slotProps">
                  <checkbox v-model="slotProps.data.alert" :binary="true"></checkbox>


              </template>
              <template #body="slotProps">
                  <checkbox v-model="slotProps.data.alert" :binary="true"></checkbox>
<!--                  <div class="subject-tracking " :class="slotProps.data.type">-->
<!--                      {{ getTypeLabel(slotProps.data.type) }}-->
<!--                  </div>-->
              </template>
          </Column>



        <template #footer>
          סה״כ {{ data ? data.length : 0 }} רשומות.
        </template>
      </DataTable>
    </div>

    <add-dialog
        :show="isDialogAdd"
        v-on:addItem="addItem"
        v-on:closeDialog="isDialogAdd = false"
    >
    </add-dialog>
    <delete-dialog
        :title="'מחיקת משתמש'"
        :context="`האם תרצה להסיר  ${selectedItemsSubjectTracing.length}   משתמשים מהמערכת?`"
        :show="isDialogDelete"
        v-on:choice="deleteItem"
    >
    </delete-dialog>
  </div>
</template>

<script>
import addDialog from "../../../dialogs/SubjectTracingDialog.vue";
import deleteDialog from "../../../dialogs/DeleteDialog.vue";
import Service from "../../../service/Service";

import Vue from "vue";

export default {
  service: null,
  components: {
    addDialog,
    deleteDialog,
  },
  created() {
    this.service = new Service();
  },
  mounted() {
    this.service.get(this.ENTITY).then((data) => {
      this.data = data;
      this.loading = false;
    });
  },
  data() {
    return {
      ENTITY: 'subject-tracing',

      data: null,
      loading: true,
      isDialogDelete: false,
      isDialogAdd: false,
      selectedItemsSubjectTracing: [],
      filters: {},
      itemBeforeEditing: {},
      itemAfterEditing: {},
      columns: [{ field: "hebrewName", header: "שם" }, { field: "sort", header: "סדר" }],
      roles: ["USER", "MIKTZOI", "ADMIN"],
      types: ["t-danger", "t-warning", "t-success", "t-help", "t-info", "t-secondary"],

    };
  },

  methods: {
    getRoleLabel(status) {
      switch (status) {
        case "ADMIN":
          return "מנהל";

        case "USER":
          return "מחנך";

        case "MIKTZOI":
          return "מקצועי";

        default:
          return "שגיאה";
      }
    },
    getTypeLabel(status) {
      switch (status) {
        case "t-danger":
          return "סכנה";
        case "t-warning":
          return "אזהרה";
        case "t-success":
          return "הצלחה";
        case "t-help":
          return "רפואה";
        case "t-info":
          return "מידע";
        case "t-secondary":
          return "שונות";
        default:
          return "שגיאה";
      }
    },
    rowClass(data) {
      return data.enabled === false ? "row-unenabled" : null;
    },
    addItem(item) {
      this.data.push(item);
    },

    deleteItem(choice) {
      this.loading = true

      this.isDialogDelete = false;
      if (choice) {

        const itemsIds = [];
        this.selectedItemsSubjectTracing.forEach((item) => {
          itemsIds.push(item.id);
        });

        this.selectedItemsSubjectTracing.forEach((selected) => {
          this.data = this.data.filter((item) => item.id !== selected.id);
        });

        this.service.deleteMany(itemsIds, this.ENTITY)
            .then(() => {
              this.loading = false
              this.openNotification("success", `מעולה`, `מחקנו ${itemsIds.length}  רשומות מהמערכת`);
              this.selectedItemsSubjectTracing = [];
            })
            .catch(() => {
              this.loading = false
              this.openNotification("danger", `אופס`, `לא הצלחנו למחוק את הרשומות מהמערכת`);
              this.data.push(...this.selectedItemsSubjectTracing)
              this.selectedItemsSubjectTracing = [];
            });

        this.isDialogDelete = false;
      }
    },

    async onCellEditComplete(event) {
        let objToSend
        if ( this.itemAfterEditing?.id === undefined){
            objToSend = event.data
        } else {
            const index = this.data.findIndex(
                (item) => item.id === this.itemAfterEditing.id
            );
            Vue.set(this.data, index, this.itemAfterEditing);
            objToSend = this.itemAfterEditing
        }
      this.service
          .update(objToSend, this.ENTITY)
          .then(() => {
          })
          .catch(() => {
            Vue.set(this.data, index, this.itemBeforeEditing);
            this.openNotification(
                "danger",
                `אופס`,
                `קרתה תקלה בעדכון הנתונים במערכת`
            );
          });
    },

    onCellEdit(newValue, props) {
      this.itemBeforeEditing = {...props.data};
      this.itemAfterEditing = {...props.data};
      this.itemAfterEditing[props.column.field] = newValue;
    },
    openNotification(color, title, text, position = "right-left", duration = 3000) {
      this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
    },
  },
};
</script>


<style scoped>
/* ::v-deep(.editable-cells-table td.p-cell-editing) {
  padding - top
:
  0;
  padding - bottom
:
  0;
}
*/

/*.p*/

/*-*/
/*multiselect*/

/*-*/
/*label*/
/*:*/

/*not*/
/*(*/
/*.p*/

/*-*/
/*placeholder*/

/*)*/
/*{*/
/*  padding -top: 0.25rem*/
/*;*/
/*  padding -bottom: 0.25rem*/
/*;*/
/*}*/

/*.country*/

/*-*/
/*item*/

/*-*/
/*value {*/
/*  padding: 0.25rem 0.5rem;*/
/*  border -radius: 3px;*/
/*  display: inline -flex;*/
/*  margin -right: 0.5rem;*/
/*  background -color: var (*/
/*  --primary -color);*/
/*  color: var (*/
/*  --primary -color -text);*/
/*}*/

/*.table*/

/*-*/
/*header {*/
/*  display: flex;*/
/*  align -items: center;*/
/*  justify -content: space -between;*/
/*}*/

/*.app*/

/*-*/
/*container {*/
/*  text -align: center;*/
/*}*/

/*.p*/

/*-*/
/*paginator {*/
/*  direction: rtl;*/
/*}*/

/*.p*/

/*-*/
/*paginator*/

/*-*/
/*icon {*/
/*  transform: scaleX(-1);*/
/*}*/

/*td {*/
/*  text -align: right !important;*/
/*}*/

/*p {*/
/*  text -align: right !important;*/
/*}*/

/*h4 {*/
/*  text -align: right !important;*/
/*}*/

/*::v*/

/*-*/
/*deep.row*/

/*-*/
/*unenabled {*/
/*  color: rgba(0, 0, 0, 0.3) !important;*/
/*}*/

/*th {*/
/*  text -align: right !important;*/
/*}*/
</style>